module.exports = __webpack_public_path__ + "static/s6-objekt1-e0ca82f78246f925504d72c5d34052c0.png";